export const env = process.env.NODE_ENV || "development";
export const dev = env === "development";
export const prod = env === "production";

export const apiBaseUrl = prod ? "" : "http://localhost:4301";
export const apiVersion = "v1";